document.addEventListener('DOMContentLoaded', function () {

  var endDate = new Date('2026-07-27T23:59:59');

  var dEl = document.getElementById('fc-wcbar-d');
  var hEl = document.getElementById('fc-wcbar-h');
  var mEl = document.getElementById('fc-wcbar-m');
  var sEl = document.getElementById('fc-wcbar-s');
  var section = document.getElementById('fc-wcbar-section');

  if (!dEl) return;

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function updateCountdown() {
    var now = new Date();
    var diff = (endDate - now) / 1000;

    if (diff <= 0) {
      if (section) section.style.display = 'none';
      return;
    }

    var d = Math.floor(diff / 86400);
    var h = Math.floor((diff % 86400) / 3600);
    var m = Math.floor((diff % 3600) / 60);
    var s = Math.floor(diff % 60);

    dEl.textContent = pad(d);
    hEl.textContent = pad(h);
    mEl.textContent = pad(m);
    sEl.textContent = pad(s);
  }

  updateCountdown();
  setInterval(updateCountdown, 1000);
});